import { useMutation } from '@tanstack/react-query';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: MJS workaround to allow in JS file
import { service } from '../client.mjs';
import { Affiliate, ApiResponse } from '../types';
import { dataOrError } from '../utils/dataOrError';

export interface AffiliateLookupIdPayload {
  agriaId: string;
}

const getAffiliateLookupId = async ({ agriaId }: AffiliateLookupIdPayload) => {
  const { data } = await service.get<ApiResponse<Pick<Affiliate, 'Id'>>>(
    '/affiliate/look-up-id',
    { params: { AgriaId: agriaId } },
  );
  return dataOrError<Pick<Affiliate, 'Id'>>(data).Id;
};

export function useAffiliateLookupId() {
  return useMutation({
    mutationFn: getAffiliateLookupId,
  });
}
